import leave from "./leaveSlice";
import leavePolicyReducer from "./leavePolicy";


const leaveReducers = {
    leave:leave,
    leavePolicy:leavePolicyReducer
};

export default leaveReducers;